/** @namespace Helper-Namspace for general Functions that can be used everywhere */
$j.extend(true, jPar, {
	Tracking: {
		init: function () {
			// Initialisierung des Event-Trackings
			try {
				// erstmal nicht mehr this.connectionType();
				// erstmal nicht mehr this.ui.standaloneWebApp();

				this.setEventForUnhandledRejection();
			} catch {
				console.error('jPar.Tracking.init failed!');
			}
		},

		setEventForUnhandledRejection: function () {
			window.addEventListener('unhandledrejection', (event) => {
				// Wenn Promises nicht richtig aufgelöst werden
				if (typeof event !== 'undefined') {
					event.preventDefault(); // Can prevent error output on the console:

					const reasonDefined = typeof event.reason !== 'undefined';
					const stackDefined = reasonDefined && typeof event.reason.stack !== 'undefined';
					const messageDefined = reasonDefined && typeof event.reason.message !== 'undefined';

					if (stackDefined && event.reason.stack !== '') {
						jPar.util.log.error(event.reason.stack, 'unhandledrejection (event.reason.stack) Caught_2'); // Caught_2
					} else if (messageDefined) {
						jPar.util.log.error(event.reason.message, 'unhandledrejection (event.reason.message) Caught_2'); // Caught_2
					}
				}
			});
		},

		parmacontoTeaser: {
			init: function () {
				const _this = this;

				document.addEventListener(
					'scroll',
					() => {
						_this.onScrollOrResizeViewed();
					},
					{ passive: true, signal: jPar.util.getGlobalAbortSignal() },
				);

				window.addEventListener(
					'resize',
					() => {
						_this.onScrollOrResizeViewed();
					},
					{ passive: true, signal: jPar.util.getGlobalAbortSignal() },
				);
			},

			onScrollOrResizeViewed: function () {
				const _this = this;
				const $allUnviewedSlots = $j('.urcCard [data-urclayout]:not(.is-viewed)');

				if ($allUnviewedSlots.length > 0) {
					$allUnviewedSlots.each(function () {
						_this.slotViewed($j(this));
					});
				}
			},

			slotLoaded: function ($loadedSlot) {
				const _this = this;
				const isVisibleSlot = $loadedSlot.height() > 0;
				if (isVisibleSlot) {
					_this.triggerPegLoggerEvent($loadedSlot, 'loaded');
				}
			},

			slotViewed: function ($loadedSlot) {
				const currentUrcSlotIsOnScreen = $loadedSlot.isOnScreen(function (deltas) {
					return deltas.top >= $loadedSlot.height() * 0.75 && deltas.bottom >= $j(this).height(); // etwas mehr luft, da das Plugin die Höhe vom Window und nicht von dem scrollbaren Kasten nimmt
				});

				if (currentUrcSlotIsOnScreen) {
					$loadedSlot.addClass('is-viewed');
					this.triggerPegLoggerEvent($loadedSlot, 'viewed');
				}
			},

			slotClicked: function ($loadedSlot) {
				const _this = this;

				$loadedSlot.on('click', function () {
					_this.triggerPegLoggerEvent($j(this), 'click');
				});
			},

			addParamsToParmacontoLink: function ($loadedSlot) {
				const currentLink = $loadedSlot.find('a').attr('href');
				if (currentLink !== undefined && currentLink !== null) {
					const linkDivider = currentLink.lastIndexOf('?') === -1 ? '?' : '&';
					const targetIdParam = 'target_id=' + $loadedSlot.data('urc-id');
					const urcTitle = '&urcTitle=' + $loadedSlot.data('urc-title');
					const slotName = '&slotName=' + $loadedSlot.parents('.urcCard').attr('id');
					const displaySize = '&displaySize=' + jPar.wdk.screensize.getCurrentScreenSize();

					const enhancedLink = currentLink + linkDivider + targetIdParam + urcTitle + slotName + displaySize;
					$loadedSlot.attr('href', enhancedLink);
				}
			},

			triggerPegLoggerEvent: function ($urcAjaxContent, action) {
				const slotName = $urcAjaxContent.data('urc-slot');
				const urcId = $urcAjaxContent.data('urc-id');
				const urcTitle = $urcAjaxContent.data('urc-title');
				// console.log(`xsendTrackEvent: ${slotName} urcId: ${urcId}`);

				jPar.util.log.bigData({
					category: 'parmacontoTeaser',
					subcategory: slotName,
					targetId: urcId + ':' + urcTitle,
					action: action,
				});
			},
		},

		registration: {
			trackLayer: function (pageName) {
				// layerName
				// mal durch /bd ersetzen?
				jPar.util.log.devConsole('Deprecated Tracking.registration.trackLayer() ', pageName);
			},
		},
	},
});
